import React, { useEffect, useState } from 'react';
import '../../../../utils/reportViewerKendoSetup';
import { TelerikReportViewer } from '@progress/telerik-react-report-viewer';
import { authService } from '../../../../index';
import { fetchConfig } from '../../../../utils/HttpClient';
import styles from './_washout-report-viewer.module.scss';

export interface WashoutReportViewerProps {
  applicationNo: number;
  reportName: string;
  clientId?: string;
}

/**
 * Inline Telerik Report Viewer for the Washout report.
 * Renders the Washout report (.trdp) within the FinanceQuoter TabStrip.
 * Auto-refreshes when the component is re-mounted (via React key prop from parent).
 */
export default function WashoutReportViewer(props: WashoutReportViewerProps) {
  const [serviceUrl, setServiceUrl] = useState<string | null>(null);
  const [bearerToken, setBearerToken] = useState<string | null>(null);

  useEffect(() => {
    const initialize = async () => {
      const config: any = await fetchConfig();
      const baseUrl = config.api_endpoint;
      setServiceUrl(`${baseUrl}/api/reports`);

      const token = await authService.getToken();
      setBearerToken(token ?? null);
    };

    initialize();
  }, []);

  // Intercept fetch to inject X-Client-Id header for multi-tenant routing
  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      let [url, options = {}] = args;

      if ((url as string)?.includes('/api/reports') === true) {
        options.headers = {
          ...options.headers,
          'X-Client-Id': props.clientId ?? '',
        };
      }

      return originalFetch(url, options);
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, [props.clientId]);

  if (!serviceUrl || !bearerToken) {
    return <div>Loading report...</div>;
  }

  return (
    <div className={styles.washoutReportContainer}>
      <TelerikReportViewer
        serviceUrl={serviceUrl}
        authenticationToken={bearerToken}
        reportSource={{
          report: props.reportName,
          parameters: {
            ApplicationNumber: props.applicationNo,
          },
        }}
        viewerContainerStyle={{
          position: 'absolute',
          left: '0px',
          right: '0px',
          top: '0px',
          bottom: '0px',
          overflow: 'hidden',
          clear: 'both',
          fontFamily: 'ms sans serif',
        }}
        viewMode="INTERACTIVE"
        scaleMode="FIT_PAGE_WIDTH"
        enableAccessibility={false}
        parametersAreaVisible={false}
      />
    </div>
  );
}
